import { ActionReducerMapBuilder, AsyncThunk } from "@reduxjs/toolkit";

export interface APIResponseType {
  data: any;
  loading: boolean;
  meta: any;
  pagination?: {
    limit?: number;
    page?: number;
    totalData?: number;
    totalPages?: number;
  };
}

const extractStateName = (typePrefix: string): string => {
  return typePrefix.includes("/") ? typePrefix.split("/")[0] : typePrefix;
};

export const createThunkCase = (
  builder: ActionReducerMapBuilder<any>,
  thunk: AsyncThunk<any, any, any>,
  stateMap: Record<string, any>
) => {
  try {
    return builder
      .addCase(thunk.pending, (state: typeof stateMap) => {
        const slice =
          state[extractStateName(thunk?.typePrefix) as keyof typeof stateMap];
        if (slice) {
          if (typeof slice === "object") {
            if ("meta" in slice) {
              slice.meta = null;
            }
            if ("loading" in slice) {
              slice.loading = true;
            }
          }
        }
      })
      .addCase(thunk.fulfilled, (state, action) => {
        const slice =
          state[extractStateName(thunk?.typePrefix) as keyof typeof stateMap];
        if (slice) {
          if (typeof slice === "object") {
            if ("data" in slice) {
              slice.data = action.payload?.data;
            }

            if (action.payload?.meta?.pagination && !slice.pagination) {
              slice.pagination = {};
            }

            slice.pagination = {
              limit: action.payload?.meta?.pagination?.limit,
              page: action.payload?.meta?.pagination?.page,
              totalData: action.payload?.meta?.pagination?.totalData,
              totalPages: action.payload?.meta?.pagination?.totalPages,
            };

            if ("loading" in slice) {
              slice.loading = false;
            }
          }
        }
      })
      .addCase(thunk.rejected, (state, action: any) => {
        const slice =
          state[extractStateName(thunk?.typePrefix) as keyof typeof stateMap];
        if (slice) {
          if (typeof slice === "object") {
            if ("meta" in slice) {
              slice.meta =
                typeof action?.payload === "string"
                  ? action?.payload
                  : action?.payload?.meta;
            }
            if ("loading" in slice) {
              slice.loading = false;
            }
          }
        }
      });
  } catch (error) {
    console.error(error);
    return null;
  }
};
